<template lang="">
    <v-app> 
         <Tabs :routes='route' :colors="'#2060d3'" />
            <v-container>
                <transition name="slide-fade">
                     <router-view></router-view>
                </transition>
            </v-container>
    </v-app>
</template>
<script>

import Tabs from '../../component/layouts/content/tabs'
import color from '../../../../plugins/assets/colors'

export default {
    
    components:{
        Tabs
    },

    data(){
        return {

            route:[
                {
                    id:1,
                    name:'Excepción activa',
                    icon:'mdi-table-large',
                    route:'/exepciones',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Exepciones',
                        disabled: true,
                        href: 'exepciones',
                        },
                        
                    ],
                
                },

                {
                    id:2,
                    name:'Generar nuevo código',
                    icon:'mdi-qrcode',
                    route:'/exepciones/crear',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Conductor',
                        disabled: false,
                        href: '/exepciones',
                        },
                        {
                        text: 'Crear',
                        disabled: true,
                        href: '/exepciones/crear',
                        },
                        
                    ],

                },
            ]

        }
    }

}
</script>